import axios from 'axios';
import consts from '../constant';

const API_BASE = consts.BackendUrl;

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
  },
});

export const getBinarySettings = async (data = {}) => {
  try {
    const response = await axios.post(`${API_BASE}/get-binary-settings`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const saveTimeSetting = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/save-time-setting`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const deleteTimeSetting = async (id) => {
  try {
    const response = await axios.post(`${API_BASE}/delete-time-setting`, { id }, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const saveAmountSetting = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/save-amount-setting`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const deleteAmountSetting = async (id) => {
  try {
    const response = await axios.post(`${API_BASE}/delete-amount-setting`, { id }, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const updateTradeSettings = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/update-trade-settings`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

/**
 * Secret Point System APIs
 */
export const getSecretPointSettings = async (rank) => {
  try {
    const url = rank ? `${API_BASE}/settings/getSecretPointSettings?rank=${rank}` : `${API_BASE}/settings/getSecretPointSettings`;
    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const updateSecretPointSettings = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/settings/updateSecretPointSettings`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

/**
 * Automated Target RTP Engine APIs
 */
export const getRtpSettings = async () => {
  try {
    const response = await axios.get(`${API_BASE}/settings/getRtpSettings`, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const updateRtpSettings = async (payload) => {
  try {
    const response = await axios.post(`${API_BASE}/settings/updateRtpSettings`, payload, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const getRtpAnalytics = async (window = '24h', forceRefresh = false) => {
  try {
    const params = new URLSearchParams({ window, forceRefresh });
    const response = await axios.get(`${API_BASE}/settings/getRtpAnalytics?${params.toString()}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const getRtpHistory = async (window = '24h', limit = 50) => {
  try {
    const params = new URLSearchParams({ window, limit });
    const response = await axios.get(`${API_BASE}/settings/getRtpHistory?${params.toString()}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const getRtpAuditTrades = async (filter = 'all', limit = 50) => {
  try {
    const params = new URLSearchParams({ filter, limit });
    const response = await axios.get(`${API_BASE}/settings/getRtpAuditTrades?${params.toString()}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

